// Shared catalog of related-record fields a custom-form template can bind to.
// Mirrors the keys returned by GET /api/custom-forms/resolve-mapping.
// Kept in its own file so non-PDF UIs can import it without pulling
// pdfjs / react-pdf into their bundle.
export const RELATED_FIELD_GROUPS = {
  customer: {
    label: 'Field from Related Customer',
    fields: [
      { value: 'customer.full_name', label: 'Full Name' },
      { value: 'customer.first_name', label: 'First Name' },
      { value: 'customer.last_name', label: 'Last Name' },
      { value: 'customer.company_name', label: 'Company Name' },
      { value: 'customer.email', label: 'Email' },
      { value: 'customer.phone', label: 'Phone' },
      { value: 'customer.mailing_address', label: 'Mailing Address' },
      { value: 'customer.mailing_city', label: 'Mailing City' },
      { value: 'customer.mailing_state', label: 'Mailing State' },
      { value: 'customer.mailing_zip', label: 'Mailing Zip' },
      { value: 'customer.county', label: 'County' },
      { value: 'customer.parcel_id', label: 'Parcel ID' },
    ],
  },
  project: {
    label: 'Field from Related Project',
    fields: [
      { value: 'project.project_number', label: 'Project Number' },
      { value: 'project.title', label: 'Project Name' },
      { value: 'project.address', label: 'Job Site Address' },
      { value: 'project.city', label: 'Job Site City' },
      { value: 'project.county', label: 'County' },
      { value: 'project.zip', label: 'Job Site Zip' },
      { value: 'project.parcel_id', label: 'Parcel ID' },
      { value: 'project.type', label: 'Project Type' },
      { value: 'project.status', label: 'Project Status' },
    ],
  },
  estimate: {
    label: 'Field from Related Estimate',
    fields: [
      { value: 'estimate.estimate_number', label: 'Estimate Number' },
      { value: 'estimate.title', label: 'Title' },
      { value: 'estimate.total', label: 'Total' },
      { value: 'estimate.subtotal', label: 'Subtotal' },
      { value: 'estimate.tax', label: 'Tax' },
      { value: 'estimate.discount', label: 'Discount' },
      { value: 'estimate.status', label: 'Status' },
      { value: 'estimate.well_address', label: 'Well Address' },
      { value: 'estimate.well_diameter', label: 'Well Diameter' },
      { value: 'estimate.well_depth', label: 'Well Depth' },
      { value: 'estimate.well_casing', label: 'Well Casing' },
      { value: 'estimate.pump_type', label: 'Pump Type' },
      { value: 'estimate.notes', label: 'Notes' },
      { value: 'estimate.terms', label: 'Terms & Conditions' },
      { value: 'estimate.line_items_text', label: 'Line Items (take-off)' },
      { value: 'estimate.line_items_summary', label: 'Line Items Summary' },
      { value: 'estimate.line_items_count', label: 'Line Items Count' },
      { value: 'estimate.created_at', label: 'Date' },
      { value: 'estimate.expiry_date', label: 'Expiry Date' },
    ],
  },
  well: {
    label: 'Field from Well Info (auto-fills Permit Application)',
    fields: [
      { value: 'well.use', label: 'Intended Use' },
      { value: 'well.work_type', label: 'Type of Work' },
      { value: 'well.depth', label: 'Total Depth (ft)' },
      { value: 'well.diameter', label: 'Well Diameter' },
      { value: 'well.septic_distance', label: 'Distance from Septic (ft)' },
      { value: 'well.drilling_method', label: 'Drilling Method' },
      { value: 'well.casing_material', label: 'Primary Casing Material' },
      { value: 'well.casing_diameter', label: 'Primary Casing Diameter' },
      { value: 'well.casing_depth', label: 'Primary Casing Depth' },
      { value: 'well.casing_from', label: 'Primary Casing From (ft)' },
      { value: 'well.casing_to', label: 'Primary Casing To (ft)' },
      { value: 'well.secondary_casing_material', label: 'Secondary Casing Material' },
      { value: 'well.secondary_casing_diameter', label: 'Secondary Casing Diameter' },
      { value: 'well.secondary_casing_from', label: 'Secondary Casing From (ft)' },
      { value: 'well.secondary_casing_to', label: 'Secondary Casing To (ft)' },
      { value: 'well.screen_from', label: 'Screen From (ft)' },
      { value: 'well.screen_to', label: 'Screen To (ft)' },
      { value: 'well.open_hole_from', label: 'Open Hole From (ft)' },
      { value: 'well.open_hole_to', label: 'Open Hole To (ft)' },
      { value: 'well.contam_zone', label: 'Contamination Zone' },
      { value: 'well.latitude', label: 'Latitude' },
      { value: 'well.longitude', label: 'Longitude' },
      { value: 'well.site_map', label: 'Site Map of Well Location (image)' },
    ],
  },
  property: {
    label: 'Field from Property Owner (Legal Owner of Record)',
    fields: [
      { value: 'property.owner_name', label: 'Legal Owner Name' },
      { value: 'property.owner_address', label: 'Owner Mailing Address' },
      { value: 'property.owner_city', label: 'Owner City' },
      { value: 'property.owner_state', label: 'Owner State' },
      { value: 'property.owner_zip', label: 'Owner Zip' },
      { value: 'property.parcel_id', label: 'Parcel / Folio Number' },
      { value: 'property.acreage', label: 'Acreage' },
      { value: 'property.use_description', label: 'Property Use' },
      { value: 'property.just_value', label: 'Just Value' },
      { value: 'property.county', label: 'County of Record' },
    ],
  },
  invoice: {
    label: 'Field from Related Invoice',
    fields: [
      { value: 'invoice.invoice_number', label: 'Invoice Number' },
      { value: 'invoice.total', label: 'Total' },
      { value: 'invoice.balance', label: 'Balance' },
      { value: 'invoice.amount_paid', label: 'Amount Paid' },
      { value: 'invoice.status', label: 'Status' },
      { value: 'invoice.due_date', label: 'Due Date' },
      { value: 'invoice.created_at', label: 'Date' },
    ],
  },
  job: {
    label: 'Field from Related Job',
    fields: [
      { value: 'job.job_number', label: 'Job Number' },
      { value: 'job.title', label: 'Title' },
      { value: 'job.status', label: 'Status' },
      { value: 'job.scheduled_date', label: 'Scheduled Date' },
      { value: 'job.completion_date', label: 'Completion Date' },
      { value: 'job.address', label: 'Site Address' },
      { value: 'job.total_well_depth', label: 'Total Well Depth (as-built, ft)' },
      { value: 'job.cased_depth', label: 'Cased Depth (as-built, ft)' },
      { value: 'job.drilled_depth', label: 'Drilled Depth (as-built, ft)' },
      { value: 'job.cutting_log', label: 'Drill Cuttings Log (block of rows)' },
    ],
  },
  permit: {
    label: 'Field from Related Permit',
    fields: [
      { value: 'permit.permit_number', label: 'Permit Number' },
      { value: 'permit.county_number', label: 'County Number' },
      { value: 'permit.county', label: 'County' },
      { value: 'permit.receipt', label: 'Receipt Number' },
      { value: 'permit.type', label: 'Type of Work' },
      { value: 'permit.well_type', label: 'Intended Use (Well Type)' },
      { value: 'permit.status', label: 'Status' },
      { value: 'permit.township', label: 'Township' },
      { value: 'permit.range', label: 'Range' },
      { value: 'permit.section', label: 'Section' },
      { value: 'permit.parcel_id', label: 'Parcel ID' },
      { value: 'permit.property_owner', label: 'Property Owner' },
      { value: 'permit.property_address', label: 'Property Address' },
      { value: 'permit.issued_date', label: 'Issued Date' },
      { value: 'permit.expiry_date', label: 'Expiry Date' },
    ],
  },
  company: {
    label: 'Company / Static Values',
    fields: [
      { value: 'company.name', label: 'Company Name' },
      { value: 'company.address', label: 'Company Address' },
      { value: 'company.city', label: 'Company City' },
      { value: 'company.state', label: 'Company State' },
      { value: 'company.zip', label: 'Company Zip' },
      { value: 'company.phone', label: 'Company Phone' },
      { value: 'company.email', label: 'Company Email' },
      { value: 'company.website', label: 'Company Website' },
      { value: 'company.license', label: 'License #' },
      { value: 'company.logo', label: 'Company Logo (image)' },
      { value: 'system.today', label: "Today's Date" },
      { value: 'system.user', label: 'Current User' },
    ],
  },
};

export const ALL_RELATED_FIELDS = Object.values(RELATED_FIELD_GROUPS).flatMap(g =>
  g.fields.map(f => ({ ...f, group: g.label }))
);
